import { render, staticRenderFns } from "./DatabricksDashboard.vue?vue&type=template&id=0270c17b&scoped=true&"
import script from "./DatabricksDashboard.vue?vue&type=script&lang=js&"
export * from "./DatabricksDashboard.vue?vue&type=script&lang=js&"
import style0 from "./DatabricksDashboard.vue?vue&type=style&index=0&id=0270c17b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0270c17b",
  null
  
)

export default component.exports